import { formatDecimals, formatRounded } from "@/lib/formatting/numbers";
import {
  ResultHeadline,
  ResultItem,
  ResultList,
} from "@/components/calculators/shared/calculator-results";
import type { GaylordVolumeEstimate, GaylordVolumeInput } from "./gaylord-volume-model";

interface GaylordVolumeResultsProps {
  input: GaylordVolumeInput;
  estimate: GaylordVolumeEstimate;
}

export function GaylordVolumeResults({ input, estimate }: GaylordVolumeResultsProps) {
  return (
    <>
      <ResultHeadline
        label="Estimated payload"
        value={`${formatRounded(estimate.payloadLbs, 0)} lb`}
        detail={`Usable volume at ${formatRounded(input.densityLbsPerCubicFoot, 1)} lb/ft³`}
      />
      <ResultList>
        <ResultItem term="Box volume" value={`${formatDecimals(estimate.totalCubicFeet, 2)} ft³`} />
        <ResultItem
          term={`Usable at ${formatRounded(input.fillPercent, 1)}% fill`}
          value={`${formatDecimals(estimate.usableCubicFeet, 2)} ft³`}
        />
        <ResultItem term="Usable cubic yards" value={`${formatDecimals(estimate.usableCubicYards, 2)} yd³`} />
      </ResultList>
    </>
  );
}
